import { c as _c } from "react/compiler-runtime";
import './supporter-identity.scss';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.tsx';
export const SupporterIdentity: React.FC<{
  variant: 'full' | 'minimal';
  name?: string;
  initials?: string;
  email?: string;
  notificationCount?: number;
}> = t0 => {
  const $ = _c(21);
  const {
    variant,
    name,
    email,
    notificationCount,
    initials
  } = t0;
  if (variant === "minimal") {
    let t1;
    if ($[0] !== initials) {
      t1 = initials || <ArkIcon iconName="user-01" />;
      $[0] = initials;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] !== notificationCount) {
      t2 = !!notificationCount && <span className="label-sm label-potent flex justify-center items-center aspect-ratio-1 absolute">{notificationCount}</span>;
      $[2] = notificationCount;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    let t3;
    if ($[4] !== t1 || $[5] !== t2) {
      t3 = <div className="relative heading-sm label-potent">{t1}{t2}</div>;
      $[4] = t1;
      $[5] = t2;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    return t3;
  }
  let t1;
  if ($[7] !== initials) {
    t1 = initials || <ArkIcon iconName="user-01" />;
    $[7] = initials;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  let t2;
  if ($[9] !== t1) {
    t2 = <div className="flex rounded-full SupporterIdentity__round shrink-0 items-center justify-center"><div className="label-xl label-potent">{t1}</div></div>;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== name) {
    t3 = name && <p className="label-xl label-potent overflow-hidden m-0 text-wrap-nowrap">{name}</p>;
    $[11] = name;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== email) {
    t4 = email && <p className="label-md label-moderate overflow-hidden text-wrap-nowrap">{email}</p>;
    $[13] = email;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== t3 || $[16] !== t4) {
    t5 = <div className="flex flex-col overflow-hidden justify-center">{t3}{t4}</div>;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== t2 || $[19] !== t5) {
    t6 = <div className="flex gap-comfy-xs px-comfy-sm lg:px-comfy-xs">{t2}{t5}</div>;
    $[18] = t2;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  return t6;
};